import { Api } from 'models/services/api';
import { CreateBusinessQuery } from 'models/services/graphql';

import { BusinessData, BusinessDataToSave } from '../index';

type DataToCreate = {
  input: BusinessDataToSave;
};

const RequestQuery = `
  mutation CreateBusiness($input: BusinessInput!) {
    ${CreateBusinessQuery}
  }
`;

type ResponseData = {
  data: {
    createBusiness: BusinessData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: BusinessData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createBusiness;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };